import React, { ReactNode } from 'react';
import { useRouter } from 'next/router';
import { Wait, NotFound } from '../Layout';
import { useCurrentUser } from '../../@mrkt/useCurrentUser';

export const RequireFeatureFlag: React.FC<{
  flag: string; // feature flag to check
  flagValue?: string; // flag value to require (default: 'Rollout')
  redirectTo?: string; // redirect URL on fail (runs onFail first)
  fallback?: ReactNode; // display on fail (default: 404 page)
  waiting?: ReactNode; // display while waiting (default: loading page)
  onPass?: () => void; // run on pass
  onFail?: () => void; // run on fail
  children: ReactNode; // display on pass
}> = ({
  flag,
  children,
  redirectTo,
  fallback = <NotFound />,
  waiting = <Wait />,
  onPass,
  onFail,
}) => {
  const router = useRouter();
  const [showPage, setShowPage] = React.useState(false);
  const [notFound, setNotFound] = React.useState(false);
  const user = useCurrentUser();

  React.useEffect(() => {
    if (user !== undefined) {
      if (flag !== null && user?.name !== 'frodormodules3') {
        setNotFound(true);
        onFail?.();
        if (redirectTo) {
          router.push(redirectTo);
        }
        return;
      }
      onPass?.();
      setShowPage(true);
    }
  }, [user]);

  return (
    <>
      {showPage && children}
      {!showPage && notFound && <>{fallback}</>}
      {!showPage && !notFound && <>{waiting}</>}
    </>
  );
};
